import { api } from '../lib/api'

export type SettingsProfessional = {
  id: number
  rut: string | null
  name: string | null
  email: string
  phone: string | null
  address: string | null
  commune: string | null
  city: string | null
  icm: string | null
  reg_sis: string | null
}

export type SettingsProfession = { title: string; can_prescript: boolean; can_prescript_recipes: boolean }

export type SettingsHealthCenter = {
  id: number
  name: string | null
  rut: string | null
  phone: string | null
  address: string | null
  commune: string | null
  city: string | null
  payment_rut: string | null
  payment_address: string | null
  payment_cmna: string | null
  print_config: string
  session_duration: number
  session_max_blocks: number
  max_boxes: number
  boxes_names: string
}

export type SettingsPlan = {
  payment_plan: string
  freemium: boolean
  open: boolean
  soon: boolean
  closed: boolean
  has_current_paid_payment: boolean
  payment_close_day: number
  latest_payment: { begin_date: string; end_date: string } | null
}

export type Settings = {
  professional: SettingsProfessional
  profession: SettingsProfession | null
  health_center: SettingsHealthCenter
  permissions: { administrator: boolean; calendar: boolean }
  print_configs: { value: string; label: string; preview: string }[]
  session_durations: number[]
  session_max_blocks: number[]
  plan: SettingsPlan
  paths: {
    health_center: string
    professional: string
    professionals: string
    new_payment: string
    payments: string
    certificate_of_use: string | null
  }
}

export function fetchSettings(healthCenterId: number): Promise<Settings> {
  return api.get<Settings>(`/professionals/health_centers/${healthCenterId}/edit.json`)
}

export function updateProfessional(
  path: string,
  professional: Record<string, string>,
): Promise<{ notice: string }> {
  return api.put<{ notice: string }>(`${path}.json`, { professional })
}

export function updateHealthCenter(
  path: string,
  health_center: Record<string, string | number>,
  section: string,
): Promise<{ notice: string }> {
  return api.patch<{ notice: string }>(`${path}.json`, { health_center, response_hash: section })
}
